module.exports = __webpack_public_path__ + "img/66F_รูปหน้าคน-ผู้หญิง.dfbbdb6d.png";